import { useFormik } from 'formik';
import React from 'react';
import VoxelAlert from '../../../components/voxel/Alert/VoxelAlert';
import VoxelDialog from '../../../components/voxel/Dialogs/VoxelDialog';
import VoxelDialogActionButton from '../../../components/voxel/Dialogs/VoxelDialogActionButton';
import VoxelDialogActions from '../../../components/voxel/Dialogs/VoxelDialogActions';
import VoxelDialogContent from '../../../components/voxel/Dialogs/VoxelDialogContent';
import VoxelInput from '../../../components/voxel/Forms/VoxelInput';
import { usersApiService } from '../../../graphql/users/usersApiService';
import VoxelText from '../../../components/voxel/Text/VoxelText';
import VoxelDialogActionSubmit from '../../../components/voxel/Dialogs/VoxelDialogActionSubmit';

export interface NewConnectionDialogShareMyTeamsDataProps {
  close: () => void;
  back: () => void;
  onSuccess: () => Promise<unknown>;
  minWidth: string;
}

export const NewConnectionDialogShareMyTeamsData: React.FC<NewConnectionDialogShareMyTeamsDataProps> =
  ({ close, onSuccess, back, minWidth }) => {
    const mutation = usersApiService.mutations.useCreateConnectionInvitation();
    const formikProps = useFormik({
      initialValues: {
        email: '',
      },
      validate: (values) => {
        if (!values.email.length || !values.email.includes('@') || values.email.length < 3) {
          return { email: 'Provide a valid email' };
        }
        return undefined;
      },
      onSubmit: (values) =>
        mutation({ sendToEmail: values.email, invitedTeamType: 'share' }).then(onSuccess),
    });

    return (
      <VoxelDialog open title="Share my team's data" onClose={close} closeOnBackdrop>
        <VoxelDialogContent classMinWidth={minWidth} className="flex flex-col gap-4">
          <VoxelAlert severity="warning" size="sm" iconSize="lg">
            This will share all of your team's project data.
          </VoxelAlert>
          <div>
            <VoxelInput
              label="Collaborator's email address"
              labelPosition="top"
              placeholder="john.doe@gmail.com"
              value={formikProps.values.email}
              onChange={(event) => formikProps.setFieldValue('email', event.target.value)}
            />
          </div>
        </VoxelDialogContent>
        <VoxelDialogActions>
          <VoxelDialogActionButton title="Back" onClick={back} />
          <VoxelDialogActionSubmit
            title="Share project data"
            onClick={formikProps.submitForm}
            disabled={formikProps.isSubmitting || !formikProps.isValid || !formikProps.dirty}
          />
        </VoxelDialogActions>
      </VoxelDialog>
    );
  };

export default NewConnectionDialogShareMyTeamsData;
